export function getFromLocalStorage<T>(key: string, defaultValue: T): T {
  try {
    const stored = localStorage.getItem(key);
    if (!stored) return defaultValue;

    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) || typeof parsed === 'object' ? parsed : defaultValue;
  } catch (err) {
    console.warn(`Failed to parse localStorage key "${key}":`, err);
    return defaultValue;
  }
}
